module.exports = __webpack_public_path__ + "static/media/42.c79e7b08.jpg";